<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
  <div class="row m-0 mt-3">
    <div class="col-md-6 p-0">
      <button class="btn btn-outline-green btn-lg btn-block" [ngClass]="{ active: tab == 'plist' }"
        (click)="changeTabList('plist')">
        Partner Amortization
      </button>
    </div>
    <div class="col-md-6 pr-0">
      <button class="btn btn-outline-green btn-lg btn-block" [ngClass]="{ active: tab == 'clist' }"
        (click)="changeTabList('clist')">
        Customer Amortization
      </button>
    </div>
  </div>

  <div class="row m-0 mt-2" *ngIf="tab=='plist'">
    <div class="col-md-12 p-0">
      <div class="row m-0 mt-2 mb-2">
        <div class="col-md-6">
          <button class="btn btn-outline-green btn-lg btn-block" [ngClass]="{ active: subTab == 'Amortization' }"
            (click)="changeSubTab('Amortization')">
            Amortization
          </button>
        </div>
        <div class="col-md-6">
          <button class="btn btn-outline-green btn-lg btn-block" [ngClass]="{ active: subTab == 'Allocation' }"
            (click)="changeSubTab('Allocation')">
            EMI Received Allocation
          </button>
        </div>
      </div>

      <div *ngIf="subTab == 'Amortization'">
        <div class="table-responsive">
          <mat-table [dataSource]="dataSource" matTableExporter #exporter="matTableExporter" [hiddenColumns]="[]"
            style="height: fit-content;">
            <ng-container matColumnDef="Period">
              <mat-header-cell class="grid-header" *matHeaderCellDef>Period</mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index" class="grid-cell">{{ row.Period }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="EMI_Amount">
              <mat-header-cell class="grid-header" *matHeaderCellDef>EMI Amount</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                <ng-container *ngIf="row.isBold"><b> {{ row.PEMI_Amount }}</b></ng-container>
                <ng-container *ngIf="!row.isBold">{{ row.PEMI_Amount }}</ng-container>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Outstanding_Principle">
              <mat-header-cell class="grid-header" *matHeaderCellDef>Outstanding Principle</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Outstanding_Principle }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="Interest">
              <mat-header-cell class="grid-header" *matHeaderCellDef>Interest</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                <ng-container *ngIf="row.isBold"><b> {{ row.Interest }}</b></ng-container>
                <ng-container *ngIf="!row.isBold">{{ row.Interest }}</ng-container>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Principle">
              <mat-header-cell class="grid-header" *matHeaderCellDef>Principle</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                <ng-container *ngIf="row.isBold"><b> {{ row.Principle }}</b></ng-container>
                <ng-container *ngIf="!row.isBold">{{ row.Principle }}</ng-container>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="DueDate">
              <mat-header-cell class="grid-header" *matHeaderCellDef>Due Date</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                <ng-container *ngIf="row.isBold"><b> {{ row.DueDate }}</b></ng-container>
                <ng-container *ngIf="!row.isBold">{{ row.DueDate }}</ng-container>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>
          <div class="row m-0 pt-2 pb-1 align-items-center" style="background: #fff;">
            <div class="col-md-8 d-flex" *ngIf="ShowImportAmortization && currentUser.IsPartnerAmortizationImport">
              <button class="mt-3 btn font-size-12 button-btn" (click)="exportTable(exporter)">
                <i class="fa fa-file-export mr-1" style="font-size:medium;cursor: pointer;"></i> Export
              </button>
              <span class="button-wrap">
                <label class="mt-3 btn font-size-12 button-btn " style="height: -webkit-fill-available;"
                  for="ImportAmortizationData">Import Amortization Data
                </label>
                <input #fileInput type="file" id="ImportAmortizationData" (change)="ImportAmortizationData($event)"
                  style="display: none"
                  accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
              </span>
              <button class="mt-3 btn font-size-12 button-btn btn-padding" (click)="ExportAmortizationTemplate()"
                *ngIf="ShowImportAmortization">
                Export (Amortization Import Template)
              </button>
            </div>
            <div class="col-md-4 text-right">
              <button type="button" (click)="onNextStep()" class="mt-3 btn font-size-12 button-btn">
                Next <i class="fa fa-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="subTab == 'Allocation'">
        <div class="table-responsive">
          <mat-table [dataSource]="dataSourcePartnerAllocation" matTableExporter #partnerExporter="matTableExporter"
            [hiddenColumns]="['Action']">
            <ng-container matColumnDef="Voucher_Id">
              <mat-header-cell class="grid-header" *matHeaderCellDef>#</mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index" class="grid-cell">{{ i + 1 }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="VoucherDate">
              <mat-header-cell class="grid-header" *matHeaderCellDef>Voucher Date</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{ row.VoucherDate }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="Voucher_No">
              <mat-header-cell class="grid-header" *matHeaderCellDef>Voucher No</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Voucher_No }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="EMI_No">
              <mat-header-cell class="grid-header" *matHeaderCellDef>EMI No</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{ row.EMI_No }}</mat-cell>
              <mat-footer-cell *matFooterCellDef>Total:</mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="AllocatedAmt">
              <mat-header-cell class="grid-header" *matHeaderCellDef>Allocated Amt</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell text-right">{{ row.AllocatedAmt }}</mat-cell>
              <mat-footer-cell *matFooterCellDef class="grid-header text-right">{{
                totalPartnerAllocation("AllocatedAmt")
                }}</mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="Principle">
              <mat-header-cell class="grid-header" *matHeaderCellDef>Principle</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell text-right">{{ row.Principle }}</mat-cell>
              <mat-footer-cell *matFooterCellDef class="grid-header text-right">{{ totalPartnerAllocation("Principle")
                }}</mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="Interest">
              <mat-header-cell class="grid-header" *matHeaderCellDef>Interest</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell text-right">{{ row.Interest }}</mat-cell>
              <mat-footer-cell *matFooterCellDef class="grid-header text-right">{{ totalPartnerAllocation("Interest")
                }}</mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="Action">
              <mat-header-cell class="grid-header" *matHeaderCellDef>Action</mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index" class="grid-cell">
                <app-lms-voucher-view-model [voucherid]="row.Voucher_Id" [VoucherFrom]="'Allocation'" [index]="i">
                  <i class="fa fa-arrow-circle-right btn_detail" aria-label="true"></i>
                </app-lms-voucher-view-model>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="grid-header"></mat-footer-cell>
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="['Voucher_Id', 'VoucherDate', 'Voucher_No', 'EMI_No', 'AllocatedAmt', 'Principle', 'Interest', 'Action']; sticky: true"></mat-header-row>
            <mat-row
              *matRowDef="let row; columns: ['Voucher_Id', 'VoucherDate', 'Voucher_No', 'EMI_No', 'AllocatedAmt', 'Principle', 'Interest', 'Action']"></mat-row>
            <mat-footer-row class="sticky-footer fontcolor"
              *matFooterRowDef="['Voucher_Id', 'VoucherDate', 'Voucher_No', 'EMI_No', 'AllocatedAmt', 'Principle', 'Interest', 'Action']; sticky: true"
              style="background: #4dc3a3"></mat-footer-row>
          </mat-table>
          <div class="row m-0 align-items-center">
            <div class="col-md-2 p-2">
              <button class="mt-3 btn font-size-12 button-btn" (click)="exportPartnerAllocation(partnerExporter)">
                <i class="fa fa-file-export mr-1" style="font-size: medium; cursor: pointer"></i>
                Export
              </button>
            </div>
            <div class="col-md-4 p-2">
              <button type="button" class="mt-3 btn font-size-12 button-btn" mat-raised-button
                (click)="PartnerUpdateLoanEMIAllocation()">
                Regenerate Allocation
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="tab=='clist'">
    <app-lms-amortization [loanSummary]="loanSummary" [PageType]="PageType"></app-lms-amortization>
  </div>
  <ng-template #previewModal>
    <div class="p-3" style="max-height: 80vh; overflow-y: auto;">
      <h3 class="mb-3">Preview Imported Data</h3>

      <div *ngIf="importPeriodMismatch" class="alert alert-danger">
        Number of periods should be {{ amortizationListList.length - 1 }}
      </div>
      <span *ngIf="message && message.length > 0">
        {{ message }} <!-- Display the first message for now -->
      </span>

      <div class="table-responsive mb-3">
        <mat-table [dataSource]="previewDataSource" class="mat-elevation-z1">

          <ng-container *ngFor="let col of previewColumns" [matColumnDef]="col">
            <mat-header-cell *matHeaderCellDef>{{ col }}</mat-header-cell>
            <mat-cell *matCellDef="let row">
              <span [ngClass]="{'table-danger': row.invalidCells?.[col]}">
                {{ row[col] }}
              </span>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="previewColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: previewColumns"></mat-row>
        </mat-table>
      </div>

      <div class="text-right">
        <button mat-raised-button color="primary" [disabled]="!isValidData" (click)="applyPreviewData()">Update</button>
        <button mat-button (click)="matDialog.closeAll()">Cancel</button>
      </div>
    </div>
  </ng-template>



</div>